import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import request from 'lib/request';
import type { NriDiagnosticsResponse } from './types';

// Atom to store the selected hours for lookback
export const hoursAtom = atom(24);

// Refresh trigger atom - increment to refetch data
const refreshCounterAtom = atom(0);

// Base async atom that depends on hoursAtom and refresh counter
const nriDiagnosticsBaseAtom = atom(async (get) => {
  const hours = get(hoursAtom);
  get(refreshCounterAtom); // Creates dependency for manual refetch
  const response = await request.get<NriDiagnosticsResponse>(
    `/admin/nri_diagnostics?hours=${hours}`
  );
  if ('error' in response) {
    throw new Error(response.error);
  }
  return response;
});

// Loadable wrapper for loading/error states
const nriDiagnosticsLoadableAtom = loadable(nriDiagnosticsBaseAtom);

// Combined atom that provides loadable state and refetch capability
export const nriDiagnosticsAtom = atom(
  (get) => get(nriDiagnosticsLoadableAtom),
  (_get, set) => {
    set(refreshCounterAtom, (c) => c + 1);
  }
);
